import React from "react";
import { ReactController } from "../react_controller";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReadOnlyPrimerGrid } from "../../components/grids/ReadOnlyPrimerGrid";
import { renderCheckinCellPrimer } from "../../components/grids/CheckinCell/renderCheckinCellPrimer";

const queryClient = new QueryClient();

export class ReadOnlyPrimerCheckinGridController extends ReactController {
  connect() {
    this.root.render(
      <QueryClientProvider client={queryClient}>
        <ReadOnlyPrimerGrid {...this.propsValue} renderCell={renderCheckinCellPrimer} />
      </QueryClientProvider>
    );
  }
} 